import { BACKEND_API_KEY, CORE_API } from '../Constants';
import { fetchJSONFromAPI } from './api';

const EVENT_TYPE = `${BACKEND_API_KEY}-events`;
const API_ENDPOINT = `/${EVENT_TYPE}`;

/**
 * Fetch all events
 *
 * @returns {Promise<import('../Kalkhoff').SparseEvent[]>} resolves to posts.
 */
export async function fetchEvents() {
  return fetchJSONFromAPI(
      CORE_API,
      API_ENDPOINT,
      {
        '_embed': 'wp:featuredmedia',
        '_fields': [
          'categories',
          'date',
          'excerpt',
          'id',
          'slug',
          'title',
          'type',
          'event_custom_fields',
          '_links', // This is required to get _embedded props
          'comment_count',
        ].join(','),
      },
  );
}

/**
 * Fetch a single Event by slug
 *
 * @param {string} slug The unique slug of the Event
 * @returns {Promise<import('../Kalkhoff').Event>} resolves to Events.
 */
export async function fetchEventBySlug(slug) {
  const Events = await fetchJSONFromAPI(
      CORE_API,
      API_ENDPOINT,
      {
        '_embed': 'wp:featuredmedia',
        'slug': slug,
      },
  );

  return Events.shift(); // Take the first Event of the top
}
